export default "__VITE_ASSET__DWIke3D0__"